import { UserOptions } from "jspdf-autotable";
import { t } from "i18next";
import { ICustomerDetails } from "../../../../models/customer/customerDetails";
import { InvoiceDetailsDto } from "../../../../models/transportOrderInvoice/invoiceDetailsDto";
import { Base } from "../../../../framework/base";

export const pdfInvoice = (
    invoice: InvoiceDetailsDto,
    products: any[],
    customerDetails: ICustomerDetails,
    ownerName: string,
    dueDate: string
) => {
    const autoTableContent: UserOptions[] = [];
    const currentDate = Base.dateToDateStr(new Date());

    autoTableContent.push({
        body: [
            [
                {
                    content: ownerName,
                    styles: {
                        halign: "left",
                        fontSize: 20,
                        textColor: "#ffffff"
                    }
                },
                {
                    content: t("common.invoice.invoice"),
                    styles: {
                        halign: "right",
                        fontSize: 20,
                        textColor: "#ffffff"
                    }
                }
            ],
        ],
        theme: "plain",
        styles: {
            fillColor: "#3366ff"
        }
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: ownerName,
                    styles: {
                        halign: "left"
                    }
                },
                {
                    content: t("common.dateLong") + ": " + currentDate
                    +"\n" + t("transport.invoicing.invoiceNumber") + ": " + invoice.invoiceNumber,
                    styles: {
                        halign: "right"
                    }
                }
            ],
        ],
        theme: "plain"
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: t("customer.customer") + ":"
                    +"\n" + customerDetails.name
                    +"\n" + customerDetails.streetAddress
                    +"\n" + customerDetails.postalCode + " " + customerDetails.city,
                    styles: {
                        halign: "left"
                    }
                },
            ],
        ],
        theme: "plain"
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: t("transport.invoicing.productsAndServices"),
                    styles: {
                        halign: "left",
                        fontSize: 14
                    }
                }
            ]
        ],
        theme: "plain"
    });

    autoTableContent.push({
        head: [
            [
                t("customer.product"),
                t("transport.order.quantity"),
                t("transport.parcel.unitPriceEUR"),
                t("transport.invoicing.totalTax"),
                t("transport.invoicing.totalPriceEUR"),
                t("common.vatRate"),
            ]
        ],
        body: products,
        theme: "striped",
        bodyStyles: {
            lineColor: "#404040",
            lineWidth: { top: 0, right: 0, bottom: 0.2, left: 0 }
        },
        headStyles: {
            fillColor: "#343a40"
        }
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: t("transport.invoicing.priceWithoutVAT"),
                    styles: {
                        halign: "right"
                    }
                },
                {
                    content: invoice.totalVatExclusiveSum.toLocaleFixed(2) + " €",
                    styles: {
                        halign: "right"
                    }
                },
            ],
            [
                {
                    content: t("transport.invoicing.totalTax"),
                    styles: {
                        halign: "right"
                    }
                },
                {
                    content: invoice.totalVatSum.toLocaleFixed(2) + " €",
                    styles: {
                        halign: "right"
                    }
                },
            ],
            [
                {
                    content: t("transport.invoicing.priceWithVAT"),
                    styles: {
                        halign: "right"
                    }
                },
                {
                    content: invoice.totalVatInclusiveSum.toLocaleFixed(2) + " €",
                    styles: {
                        halign: "right"
                    }
                },
            ],
        ],
        theme: "plain",
        styles: {
            cellPadding: 0
        }
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: t("common.invoice.paymentDetails"),
                    styles: {
                        halign: "left",
                        fontSize: 14
                    }
                }
            ]
        ],
        theme: "plain"
    });

    autoTableContent.push({
        body: [
            [
                {
                    content: t("common.invoice.receiverIban"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: "",
                    styles: {
                        halign: "left",
                    }
                },
            ],
            [
                {
                    content: t("common.invoice.bic"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: "",
                    styles: {
                        halign: "left"
                    }
                },
            ],
            [
                {
                    content: t("common.invoice.receiver"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: ownerName,
                    styles: {
                        halign: "left"
                    }
                },
            ],
            [
                {
                    content: t("common.invoice.referenceNumber"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: invoice.reference,
                    styles: {
                        halign: "left"
                    }
                },
            ],
            [
                {
                    content: t("common.invoice.invoiceDueDate"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: invoice.totalVatInclusiveSum > 0 ? dueDate : "",
                    styles: {
                        halign: "left"
                    }
                },
            ],
            [
                {
                    content: t("common.invoice.invoiceDue"),
                    styles: {
                        halign: "left",
                        fontStyle: "bold"
                    }
                },
                {
                    content: invoice.totalVatInclusiveSum.toLocaleFixed(2) + " €",
                    styles: {
                        halign: "left"
                    }
                },
            ],
        ],
        theme: "striped",
        styles: {
            cellPadding: 1,
        },
        tableLineColor: "#404040",
        tableLineWidth: 0.2,
        tableWidth: 100,
    });

    return autoTableContent;
};
